module.exports = __webpack_public_path__ + "img/office-1.dba241fb.webp";